import { useCallback } from "react";
import { ChevronUp, ChevronDown } from "lucide-react";

export const COLUMN_SIZE_CONFIG = {
  sm: { itemHeight: 32, width: "w-[48px]", icon: "h-3 w-3",   text: "text-sm",   py: "py-1",   p: "p-px"  },
  md: { itemHeight: 38, width: "w-[56px]", icon: "h-3.5 w-3.5", text: "text-base", py: "py-1",   p: "p-0.5" },
  lg: { itemHeight: 44, width: "w-[64px]", icon: "h-4 w-4",   text: "text-lg",   py: "py-1.5", p: "p-0.5" },
};

export default function TimeWheelColumn({
  items,
  selectedIndex,
  scrollRef,
  onScroll,
  onStep,
  format = (v) => v,
  className = "",
  size = "lg",
}) {
  const cfg = COLUMN_SIZE_CONFIG[size] ?? COLUMN_SIZE_CONFIG.lg;
  const { itemHeight, width, icon, text, py, p } = cfg;
  const setRef = useCallback(
    (node) => {
      if (scrollRef) scrollRef.current = node;
    },
    [scrollRef]
  );

  return (
    <div
      className={[
        "flex flex-col items-center gap-0.5 rounded-xl border border-field-border dark:border-white/20 bg-field",
        width, py,
        className,
      ].join(" ")}
    >
      <button
        type="button"
        aria-label="Increase"
        className={`text-muted hover:text-foreground transition-colors ${p}`}
        onClick={() => onStep(1)}
      >
        <ChevronUp className={icon} />
      </button>

      <div
        ref={setRef}
        onScroll={onScroll}
        className="w-full overflow-y-scroll scrollbar-none snap-y snap-mandatory overscroll-contain"
        style={{ height: itemHeight }}
      >
        {items.map((v, i) => (
          <div
            key={`${v}-${i}`}
            className="snap-center flex items-center justify-center select-none"
            style={{ height: itemHeight, scrollSnapStop: "always" }}
          >
            <span
              className={[
                "transition-opacity duration-120",
                i === selectedIndex ? `opacity-100 font-semibold lg:font-normal ${text} text-foreground` : "opacity-0",
              ].join(" ")}
            >
              {format(v)}
            </span>
          </div>
        ))}
      </div>

      <button
        type="button"
        aria-label="Decrease"
        className={`text-muted hover:text-foreground transition-colors ${p}`}
        onClick={() => onStep(-1)}
      >
        <ChevronDown className={icon} />
      </button>
    </div>
  );
}